const API_URL = "https://book-library-api.projects.telerikacademy.com";
export { API_URL };
